import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';

const LazyCom = ({ children }) => {

  return (
    <Suspense
      fallback={
        <div
          style={{
            height: '84%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Spin spinning={true} />
        </div>
      }>
      {children}
    </Suspense>
  )
}

// Dashboard
const Dashboard = lazy(() => import('@src/views/Dashboard'));

// User
const AccountSettings = lazy(() => import('@src/views/AccountSettings'));
const LoginLogs = lazy(() => import('@src/views/LoginLogs'));
const OperationLogs = lazy(() => import('@src/views/OperationLogs'));
const MessageNotify = lazy(() => import('@src/views/MessageNotify'));

// Network Management
const ProjectManagement = lazy(() => import('@src/views/ProjectManagement'));
const PEMonitoring = lazy(() => import('@src/views/PEMonitoring'));
const BackboneMonitoring = lazy(() => import('@src/views/BackboneMonitoring'));

// Network Platform
const ResourcePlatform = lazy(() => import('@src/views/ResourcePlatform'));
const ResourcePE = lazy(() => import('@src/views/ResourcePE'));
const ResourceUnderlay = lazy(() => import('@src/views/ResourceUnderlay'));
const ResourceOverlay = lazy(() => import('@src/views/ResourceOverlay'));
const ResourceCPE = lazy(() => import('@src/views/ResourceCPE'));
const SoftwareClient = lazy(() => import('@src/views/SoftwareClient'));
const SmartCPEAcceleration = lazy(() => import('@src/views/SmartCPEAcceleration'));

// Business Operation
const CustomerManagement = lazy(() => import('@src/views/CustomerManagement'));
const Pricebook = lazy(() => import('@src/views/Pricebook'));
const LicenseManagement = lazy(() => import('@src/views/LicenseManagement'));
const InvoiceManagement = lazy(() => import('@src/views/InvoiceManagement'));
const TermsAndConitions = lazy(() => import('@src/views/TermsAndConitions'));


// Site Admin
const SiteQuota = lazy(() => import('@src/views/SiteQuota'));
const EmailSetting = lazy(() => import('@src/views/EmailSetting'));
const StorageWarehouse = lazy(() => import('@src/views/StorageWarehouse'));
const DomainKey = lazy(() => import('@src/views/DomainKey'));
const PEDNS = lazy(() => import('@src/views/PEDNS'));
const HelpDocument = lazy(() => import('@src/views/HelpDocument'));
const SiteFeatures = lazy(() => import('@src/views/SiteFeatures'));
const PortalUser = lazy(() => import('@src/views/PortalUser'));
const MessageCenter = lazy(() => import('@src/views/MessageCenter'));
const CompanyInformation = lazy(() => import('@src/views/CompanyInformation'));



/*
* link 如有子级增加在 children 中，link应是唯一，防止mainRoutes中过滤错误
* link: $1-$2： $1应在全局路由唯一，$2应在子级唯一
* menu 路由命名采用 (一级)-(二级)-(三级)
* 页面中嵌套路由禁止使用 - 连接，应使用驼峰命名，否则menu会匹配错误
*/

// 左侧menu路由
const leftMenu = [
  {
    title: 'Dashboard',
    icon: 'icon-dashboard',
    link: '/dashboard',
    permissions: ['Dashboard'],
    component: <LazyCom><Dashboard /></LazyCom>
  },
  {
    title: 'Network Management',
    icon: 'icon-relation',
    link: '/networkManage',
    children: [
      {
        title: 'Project Management',
        link: '/networkManage-project',
        permissions: 'NetworkManagement-ProjectManagement',
        component: <LazyCom><ProjectManagement /></LazyCom>
      },
      {
        title: 'PE Monitoring',
        link: '/networkManage-peMonitoring',
        permissions: 'NetworkManagement-PEMonitoring',
        component: <LazyCom><PEMonitoring /></LazyCom>,
      },
      {
        title: 'Backbone Monitoring',
        link: '/networkManage-backbone',
        permissions: 'NetworkManagement-BackboneMonitoring',
        component: <LazyCom><BackboneMonitoring /></LazyCom>,
      }
    ]
  },
  {
    title: 'Network Platform',
    icon: 'icon-network',
    link: '/networkPlatform',
    children: [
      // {
      //   title: 'Resource',
      //   link: '/networkPlatform-Resource',
      //   permissions: 'NetworkPlatform-Resource',
      //   component: <LazyCom><ResourcePlatform /></LazyCom>,
      // },
      {
        title: 'PE',
        link: '/networkPlatform-PE',
        permissions: 'NetworkPlatform-PE',
        component: <LazyCom><ResourcePE /></LazyCom>,
      },
      {
        title: 'Underlay',
        link: '/networkPlatform-Underlay',
        permissions: 'NetworkPlatform-Underlay',
        component: <LazyCom><ResourceUnderlay /></LazyCom>,
      },
      {
        title: 'DPI Management',
        link: '/networkPlatform-Overlay',
        permissions: 'NetworkPlatform-Overlay',
        component: <LazyCom><ResourceOverlay /></LazyCom>,
      },
      // {
      //   title: 'Smart CPE Acceleration',
      //   link: '/networkPlatform-SmartCPEAcceleration',
      //   permissions: 'NetworkPlatform-SmartCPEAcceleration',
      //   component: <LazyCom><SmartCPEAcceleration /></LazyCom>,
      // },
      {
        title: 'CPE',
        link: '/networkPlatform-CPE',
        permissions: 'NetworkPlatform-CPE',
        component: <LazyCom><ResourceCPE /></LazyCom>,
      },
      {
        title: 'ULOO Client',
        link: '/networkPlatform-SoftwareClient',
        permissions: 'NetworkPlatform-SoftwareClient',
        component: <LazyCom><SoftwareClient /></LazyCom>,
      }
    ]
  },
  {
    title: 'Business Operation',
    icon: 'icon-safe',
    link: '/BusinessOperation',
    children: [
      {
        title: 'Customer Management',
        link: '/BusinessOperation-customerManage',
        permissions: 'BusinessOperation-CustomerManagement',
        component: <LazyCom><CustomerManagement /></LazyCom>,
      },
      {
        title: 'Pricebook',
        link: '/BusinessOperation-pricebook',
        permissions: 'BusinessOperation-Pricebook',
        component: <LazyCom><Pricebook /></LazyCom>,
      },
      {
        title: 'License Management',
        link: '/BusinessOperation-licenseManage',
        permissions: 'BusinessOperation-LicenseManagement',
        component: <LazyCom><LicenseManagement /></LazyCom>,
      },
      {
        title: 'Invoice Management',
        link: '/BusinessOperation-invoiceManage',
        permissions: 'BusinessOperation-InvoiceManagement',
        component: <LazyCom><InvoiceManagement /></LazyCom>,
      },
      {
        title: 'Terms and Conditions',
        link: '/BusinessOperation-termsAndConitions',
        permissions: 'BusinessOperation-TermsAndConitions',
        component: <LazyCom><TermsAndConitions /></LazyCom>,
      }
    ]
  },
  {
    title: 'Site Admin',
    icon: 'icon-user-site',
    link: '/siteAdmin',
    children: [
      {
        title: 'Site Quota',
        link: '/siteAdmin-quota',
        permissions: 'SiteAdmin-SiteQuota',
        component: <LazyCom><SiteQuota /></LazyCom>,
      },
      {
        title: 'E-Mail',
        link: '/siteAdmin-email',
        permissions: 'SiteAdmin-Email',
        component: <LazyCom><EmailSetting /></LazyCom>,
      },
      {
        title: 'Object Storage',
        link: '/siteAdmin-storage',
        permissions: 'SiteAdmin-StorageWarehouse',
        component: <LazyCom><StorageWarehouse /></LazyCom>,
      },
      {
        title: 'Domain/key',
        link: '/siteAdmin-domain',
        permissions: 'SiteAdmin-Domain/Key',
        component: <LazyCom><DomainKey /></LazyCom>,
      },
      {
        title: 'PE DNS',
        link: '/siteAdmin-PE-DNS',
        permissions: 'SiteAdmin-PEDNS',
        component: <LazyCom><PEDNS /></LazyCom>,
      },
      // {
      //   title: 'Documentation',
      //   link: '/siteAdmin-helpDocument',
      //   component: <HelpDocument />
      // },
      // {
      //   title: 'Site Features',
      //   link: '/siteAdmin-siteFeatures',
      //   permissions: 'SiteAdmin-SiteFeatures',
      //   component: <LazyCom><SiteFeatures /></LazyCom>,
      // },
      {
        title: 'Portal User',
        link: '/siteAdmin-portalUser',
        permissions: 'SiteAdmin-PortalUser',
        component: <LazyCom><PortalUser /></LazyCom>,
      },
      {
        title: 'Message Center',
        icon: 'icon-icon-user',
        link: '/siteAdmin-messageCenter',
        component: <LazyCom><MessageCenter /></LazyCom>,
      },
      {
        title: 'Company Information',
        link: '/siteAdmin-companyInformation',
        permissions: 'SiteAdmin-CompanyInformation',
        component: <LazyCom><CompanyInformation /></LazyCom>,
      },
    ]
  },

  // {
  //   title: '测试三级路由',
  //   icon: 'icon-dashboard',
  //   link: '/test',
  //   children: [
  //     {
  //       title: 'Test Management',
  //       link: '/test-project',
  //       icon: 'icon-dashboard',
  //       component: <ProjectManagement />,
  //       children: [
  //         {
  //           title: 'Test 2222',
  //           link: '/test-project-2222',
  //           component: <Dashboard />,
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Test 3333',
  //       link: '/test-333',
  //       component: <ProjectManagement />,
  //     },
  //   ]
  // },
];

// 右上角头像侧路由
const headPortraitRoutes = [
  {
    title: 'Account Settings',
    icon: 'icon-icon-user',
    link: '/accountSettings',
    component: <LazyCom><AccountSettings /></LazyCom>,
  },
  {
    title: 'Login Logs',
    icon: 'icon-icon-user',
    link: '/loginLogs',
    component: <LazyCom><LoginLogs /></LazyCom>,
  },
  {
    title: 'Operation Logs',
    icon: 'icon-icon-user',
    link: '/operationLogs',
    component: <LazyCom><OperationLogs /></LazyCom>,
  },
  {
    title: 'Message Notification',
    icon: 'icon-icon-user',
    link: '/MessageNotify',
    component: <LazyCom><MessageNotify /></LazyCom>
  }
];

const mainRoutes = [...leftMenu, ...headPortraitRoutes];

export {
  leftMenu,
  headPortraitRoutes,
  mainRoutes
};
